import React from 'react';
import {
	Container,
	Header,
	SpaceBetween,
} from '@amzn/awsui-components-console';

import { requirementFormProps } from './requirementForm.interface';
import SNOWFormAttribute from 'src/components/commonComponents/SNOWFormAttribute/SNOWFormAttribute';
import { useAutoPopulation } from 'src/components/selfServeWorkflows/requirementsPortal/autoPopulation/AutoPopulationProvider';

export default function RequirementForm({
	requirements,
	title,
	taskId = null,
	isIBFR,
	prefilledValues,
	handleAutoPopulation,
	disabledFields,
	footer,
}: requirementFormProps) {
	const { autopopulatingAttributes } = useAutoPopulation();

	return (
		<Container header={<Header>{title}</Header>} key={taskId}>
			<SpaceBetween size="l">
				{
					requirements?.map(
						(requirement) => {
							const {
								attributeName,
								value,
								description,
								dataType,
								regex,
								options,
								helpText,
								mandatory,
							} = requirement;
							const isOverridable = (requirement as any).isOverridable;
							const formAttributeId = `${taskId || 'EntityData'}.${attributeName}`;
							const isAutopopulating = autopopulatingAttributes.has(formAttributeId);
							const isFieldDisabled = disabledFields?.has(attributeName!) || false;

							if (!value || isOverridable == true) {
								if (isIBFR) {
									let prefilledValue = '';

									if (attributeName !== undefined) {
										prefilledValue = prefilledValues[attributeName];
									}

									return (
										<SNOWFormAttribute
											attributeId={formAttributeId}
											key={attributeName}
											attributeName={attributeName}
											description={description}
											dataType={dataType}
											placeholder={helpText}
											regex={regex}
											mandatory={(mandatory === false || prefilledValue !== undefined || attributeName === 'metadata' || attributeName === 'keys') ? false : true}
											options={options}
											prefetchedValue={prefilledValue}
											handleAutoPopulation={handleAutoPopulation}
											isAutopopulating={isAutopopulating}
											isOverridable={isOverridable}
											disabled={isFieldDisabled}
											persistAsString
										/>
									);
								} else {
									return (
										<SNOWFormAttribute
											attributeId={formAttributeId}
											key={attributeName}
											attributeName={attributeName}
											description={description}
											dataType={dataType}
											placeholder={helpText}
											regex={regex}
											mandatory={mandatory !== false}
											options={options}
											prefetchedValue={value || undefined}
											handleAutoPopulation={handleAutoPopulation}
											isAutopopulating={isAutopopulating}
											isOverridable={isOverridable}
											disabled={isFieldDisabled}
											persistAsString
										/>
									);
								}
							}
						}
					)}
				{footer}
			</SpaceBetween>
		</Container>
	);
}
